<div class="text-center empty-container">
  <img src="../../../../../assets/images/icons/empty_folder.png" />
  <h3 class="font font-18 font font-primary text-grey-alt">
    Actualmente no has realizado ningún pago.
  </h3>
</div>
